import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  optionalContainer: {
    borderRadius: theme.spacing(5),
    background: 'rgba(171, 175, 179, 0.2)',
  },
  optionalText: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '25px',
  },
  submitBtnContainer: {
    paddingTop: '45px',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '20px',
    },
  },
  btnContainer: {
    paddingRight: theme.spacing(2.5),
  },
}));
